import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-header" }
const _hoisted_2 = { class: "content-title" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "modal-body scroll-wrapper" }
const _hoisted_5 = {
  key: 0,
  class: "content-house"
}
const _hoisted_6 = { class: "content-img-house-selected" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "content-details-house-selected" }
const _hoisted_9 = { class: "content-lot-features" }
const _hoisted_10 = { class: "lot-title" }
const _hoisted_11 = { class: "content-details-price" }
const _hoisted_12 = { class: "content-row" }
const _hoisted_13 = { class: "value-row" }
const _hoisted_14 = { class: "content-row" }
const _hoisted_15 = { class: "value-row" }
const _hoisted_16 = { class: "content-row" }
const _hoisted_17 = { class: "value-row bold" }
const _hoisted_18 = { class: "total" }
const _hoisted_19 = { class: "content-info" }
const _hoisted_20 = { class: "content-logo-info" }
const _hoisted_21 = ["src"]
const _hoisted_22 = { class: "input-row form-group" }
const _hoisted_23 = { class: "input-wr" }
const _hoisted_24 = {
  key: 0,
  class: "error"
}
const _hoisted_25 = { class: "input-wr" }
const _hoisted_26 = {
  key: 0,
  class: "error"
}
const _hoisted_27 = { class: "input-row form-group" }
const _hoisted_28 = { class: "input-wr" }
const _hoisted_29 = {
  key: 0,
  class: "error"
}
const _hoisted_30 = { class: "input-wr" }
const _hoisted_31 = {
  key: 0,
  class: "error"
}
const _hoisted_32 = { class: "controls" }
const _hoisted_33 = ["disabled"]
const _hoisted_34 = {
  key: 0,
  class: "spinner spinner-small"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Modal"], {
    isOpen: $setup.props.isOpen,
    onClose: $setup.onClose,
    classes: ['select-builder-quote-modal']
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "modal-title" }, "Secure this package", -1)),
          _createElementVNode("img", {
            class: "secure-logo",
            src: require(`@/assets/icons/icon-lock-green-secure.svg`)
          }, null, 8, _hoisted_3)
        ]),
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "line" }, null, -1))
      ]),
      _createElementVNode("div", _hoisted_4, [
        ($setup.props.house && $setup.props.lot)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("img", {
                  class: "img-house",
                  src: $setup.facade.url
                }, null, 8, _hoisted_7)
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, "Lot " + _toDisplayString($setup.props.lot.lotId.title), 1),
                  _createVNode($setup["HouseFeatures"], {
                    features: $setup.props.house,
                    directionLogo: true,
                    iconSize: 'tiny-min',
                    class: _normalizeClass('house-features')
                  }, null, 8, ["features"])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _cache[7] || (_cache[7] = _createElementVNode("div", { class: "label-row" }, "Land Price:", -1)),
                    _createElementVNode("div", _hoisted_13, _toDisplayString($setup.formatPrice($setup.props.lot.lotId.price)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _cache[8] || (_cache[8] = _createElementVNode("div", { class: "label-row" }, "Build Price:", -1)),
                    _createElementVNode("div", _hoisted_15, _toDisplayString($setup.buildPriceWithFacade) + "*", 1)
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _cache[10] || (_cache[10] = _createElementVNode("div", { class: "label-row bold" }, "Package Price:", -1)),
                    _createElementVNode("div", _hoisted_17, [
                      _cache[9] || (_cache[9] = _createElementVNode("div", { class: "from" }, "From", -1)),
                      _createElementVNode("div", _hoisted_18, _toDisplayString($setup.TotalPriceWithFacade), 1)
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("img", {
              class: "logo-info",
              src: require(`@/assets/icons/icon-info-reserve.webp`)
            }, null, 8, _hoisted_21)
          ]),
          _cache[11] || (_cache[11] = _createElementVNode("div", { class: "content-text" }, "This package looks great! Nice work. If you’d like to secure this package please complete your details below. We will contact you to confirm your personalisations and calculate a fixed build price for your selected lot.", -1))
        ]),
        _cache[16] || (_cache[16] = _createElementVNode("div", { class: "title-buyer" }, "Buyer Details", -1)),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _cache[12] || (_cache[12] = _createElementVNode("div", { class: "label bold" }, "First Name", -1)),
            _withDirectives(_createElementVNode("input", {
              class: "input-default",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.form.firstName) = $event)),
              placeholder: "First Name"
            }, null, 512), [
              [_vModelText, $setup.form.firstName]
            ]),
            ($setup.v$.firstName.$error)
              ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString($setup.v$.firstName.required.$message), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_25, [
            _cache[13] || (_cache[13] = _createElementVNode("div", { class: "label bold" }, "Last Name", -1)),
            _withDirectives(_createElementVNode("input", {
              class: "input-default",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.form.lastName) = $event)),
              placeholder: "Last Name"
            }, null, 512), [
              [_vModelText, $setup.form.lastName]
            ]),
            ($setup.v$.lastName.$error)
              ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString($setup.v$.lastName.required.$message), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            _cache[14] || (_cache[14] = _createElementVNode("div", { class: "label bold" }, "Phone", -1)),
            _createVNode($setup["Cleave"], {
              class: "input-default",
              placeholder: $setup.phonePlaceholder,
              modelValue: $setup.form.phone,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.form.phone) = $event)),
              options: $setup.phoneNumberOption($setup.form.phone)
            }, null, 8, ["placeholder", "modelValue", "options"]),
            ($setup.v$.phone.$error)
              ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString($setup.v$.phone.$errors[0]?.$message), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_30, [
            _cache[15] || (_cache[15] = _createElementVNode("div", { class: "label bold" }, "Email", -1)),
            _withDirectives(_createElementVNode("input", {
              class: "input-default",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.form.email) = $event)),
              type: "email",
              placeholder: "Email"
            }, null, 512), [
              [_vModelText, $setup.form.email]
            ]),
            ($setup.v$.email.$error)
              ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString($setup.v$.email.required.$message), 1))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_32, [
        _createElementVNode("button", {
          class: "button default primary large long",
          disabled: $setup.isLoading || $setup.isDisabledSecure,
          onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.props.quote.isAdminPackage ? $setup.submitPackage() : $setup.submitQuote()))
        }, "Secure", 8, _hoisted_33),
        ($setup.isLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_34))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          class: "button-cancel-border default large",
          onClick: $setup.onClose
        }, "Cancel")
      ])
    ]),
    _: 1
  }, 8, ["isOpen"]))
}